export const JOBS_ROUTES = {
	jobs: "/jobs",
	appJobs: "/app/jobs",
	appJobsManage: "/app/jobs/manage",
} as const;
